/* move_os_plan_associations.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.2 20.45" preserveAspectRatio="none">
            <path class="foreground-gl" d="M354.69,0a10.17,10.17,0,0,0-7.59,3.39,7.14,7.14,0,0,1,4.51,2.7l3.47-4.16,5.71,6.83h-3.42v3.67h3.42l-5.71,6.16-3.48-3.77a7.16,7.16,0,0,1-4.15,2.62A10.22,10.22,0,1,0,354.69,0Z" transform="translate(-342.71)" />
            <polygon class="foreground-gl" points="2.8 4.75 8.95 10.44 2.8 16.14 2.8 12.73 0 12.73 0 8.16 2.8 8.16 2.8 4.75" />
        </svg>
    `
};
